export default __webpack_public_path__ + "static/illustration-avatar.url-8ed322225afcdc8b7e038d5395f3914f.svg";